import React, { Component } from 'react';
import { Switch } from 'antd';

import AvisSelectorPeriode from './avisSelectorPeriode';
import AvisMonitoritzacio from './avisMonitoritzacio';

class AvisSelectorModeObtencioAvisos extends Component {

    constructor(props) {
        super(props);
        this.state = { modeMonitoritzacioActivat: false };
        this.onChangeModeVisualitzacio = this.onChangeModeVisualitzacio.bind(this);
    }

    onChangeModeVisualitzacio(checked) {
        this.setState({ modeMonitoritzacioActivat: checked });
    }

    render() {
        const { modeMonitoritzacioActivat } = this.state;
        return <div className='avis-selector-mode-obtencio-avisos'>
            {modeMonitoritzacioActivat ? <AvisMonitoritzacio /> : <AvisSelectorPeriode />}
            <span className='selector-monitoritzacio'>
                <span className='small'>Monitorar</span>
                <Switch
                    checked={modeMonitoritzacioActivat}
                    onChange={this.onChangeModeVisualitzacio} />
            </span>
        </div>;
    }
}

export default AvisSelectorModeObtencioAvisos;



// WEBPACK FOOTER //
// ./src/components/avis/avisSelectorModeObtencioAvisos.js